
    var riot = require('riot')
    //src: starling/src/tags/menu/items/menu-item-attribute-editor.html
riot.tag2('menu-item-attribute-editor',
  '<i class="fa fa-tags floating-menu_icon"></i> <span class="floating-menu_label">Attributes</span> <svg class="floating-menu_caret"> <use xlink:href="#caret-right-icon"></use> </svg>',
  '',
  'class="{opts.classes} floating-menu_item" onmouseenter="{openAttributeMenu}"', function(opts) {
'use strict';

var _this = this;

var _delayHandler = require('lib/delay-handler');

var _constants = require('lib/constants');

var parent = this.parent;

var canvas = parent.opts.canvas;

this.openAttributeMenu = function () {
  var node = parent.singleCardMenu ? canvas.store.getNode(_this.parent.getSelectedNodeIds()[0]) : null;
  var isBulkAction = parent.singleCardMenu ? false : true;

  _delayHandler.delayHandler.initializeDelay({
    action: 'submenus',
    id: 'attributes',
    delay: _constants.MENU_OPEN_DELAY,
    callback: function callback() {
      _this.parent.hideSubMenus();

      canvas.nodeAttributeEditor.summon({
        referenceEl: _this.root,
        node: node,
        isBulkAction: isBulkAction,
        positionToLeft: parent.positionSubToLeft,
        origin: parent.menuName
      });
    }
  });
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('menu-item-attribute-editor')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/menu/items/menu-item-attribute-editor.html
// module id = 698
// module chunks = 0